import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useBanner = (id) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  const query = useQuery({
    queryKey: ['banner', id],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/banner/${id}` });
      return result;
    },
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0
  });

  return query;
};
